<template>
    <div id="rechner-container">
        <form class="sk-input-form">
            <div class="input-group">
                <label class="little-label" for="forderung">Ein Forderungsausfall von</label>
                <span class="sk-formatted-input little-label">
                    <input id="forderung" lang="de-DE" type="text" step="any" v-model="forderungInput" placeholder="Betrag Forderungsausfall in €">
                     Euro
                </span>
            </div>
            <div class="input-group">
                <label class="little-label" for="rendite">Umsatzrendite</label>
                <span class="sk-formatted-input little-label">
                    <input id="rendite" type="number" v-model="rendite" placeholder="Umatzrendite in %">
                     %
                </span>
            </div>

        </form>
        <div class="sk-result-panel">
            <p>Um einen Forderungsausfall in Höhe von <span class="signal"> <span>{{forderungPretty}}</span> Euro</span> bei einer <span class="signal">Umsatzrendite von {{rendite}}%</span> auszugleichen, ist ein <span class="signal">Mehrumsatz von ca.
            <span>
                <animated-integer ref="mu" :value="mehrumsatz"></animated-integer>
            </span> Euro</span> erforderlich.</p>
        </div>
    </div>
</template>

<script>
    import AnimatedInteger from './AnimatedInteger';

    export default {
        name: "rechner",
        components: {AnimatedInteger},
        data() {
            return {
                forderung: 10000,
                rendite: 5
            }
        },
        computed: {
            mehrumsatz: {
                get: function(){
                    return (this.forderung * 100 / this.rendite);
                }
            },
            forderungPretty: function(){
                let raw = Number(this.forderung);
                return (raw.toLocaleString('de-DE',{ minimumFractionDigits: 0, maximumFractionDigits: 0 }));
            },
            forderungInput: {
                get(){
                    return this.forderung.toLocaleString('de-DE',{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
                },
                set(s){
                    s = s.replace(/[\D\s._-]+/g, "");
                    this.forderung = Number(s);
                }
            }
        },
        methods: {
        }
    }
</script>

<style>
    .signal {
        font-weight: bold;
    }

</style>
